import React from 'react'
import Text from '../../components/text/Text'
import WizButton from '../../components/button/WizButton'
import ContentBlocksInlinePreview from './ContentBlocksInlinePreview'
import {AI_FEED_CATEGORY_LABEL} from './constants'
import {formBodyToBlocks} from './utils'
import {IFormBody} from './types'

interface IProps {
    open: boolean
    mode: 'create' | 'edit'
    body: IFormBody
    onConfirm: () => void
    onCancel: () => void
}

// 생성/수정 저장 직전, 실제 발행될 내용(미리보기 + 방출 blocks JSON)을 확인시키고 진행 여부를 묻는 모달.
const ConfirmSubmitModal: React.FC<IProps> = ({open, mode, body, onConfirm, onCancel}) => {
    if (!open) return null
    const title = mode === 'create' ? '이대로 생성하시겠습니까?' : '이대로 수정하시겠습니까?'

    return (
        <div className={'fixed inset-0 z-modal flex items-center justify-center'}>
            <div className={'absolute inset-0 bg-black/50'} onClick={onCancel} />
            <div className={'relative z-10 w-[90%] max-w-[520px] bg-white rounded-[8px] p-[24px] shadow-hover'}>
                <Text className={'text-h3 text-font01'}>{title}</Text>
                <Text className={'text-ti3 text-font03 mt-[6px]'}>
                    {body.category ? AI_FEED_CATEGORY_LABEL[body.category] : ''}
                </Text>

                <Text className={'text-body3 text-font02 mt-[16px] mb-[6px]'}>미리보기</Text>
                <div
                    className={
                        'border border-line02 rounded-[8px] px-[16px] py-[12px] bg-line04 text-body1 leading-[1.8]'
                    }>
                    <ContentBlocksInlinePreview
                        blocks={body.content_blocks}
                        imageClassName={'block w-full h-auto mx-auto my-[10px] rounded-[6px]'}
                    />
                </div>

                <Text className={'text-body3 text-font02 mt-[16px] mb-[6px]'}>blocks JSON</Text>
                <pre
                    className={
                        'text-ti3 text-font02 whitespace-pre-wrap break-all border border-line02 rounded-[8px] px-[16px] py-[12px] bg-line04 max-h-[30vh] overflow-y-auto'
                    }>
                    {JSON.stringify(formBodyToBlocks(body), null, 2)}
                </pre>

                <div className={'mt-[24px] flex items-center justify-end gap-x-[10px]'}>
                    <WizButton text={'취소'} type={'cancel'} onClick={onCancel} />
                    <WizButton text={mode === 'create' ? '생성' : '수정'} type={'primary'} onClick={onConfirm} />
                </div>
            </div>
        </div>
    )
}

export default ConfirmSubmitModal
